import downloadJson from "./downloadJson";

export const GroupJsonExporter = (groups, fetchRelatedRecords) => {
    downloadJson(JSON.stringify(groups),'groups');
};
